<section class="redirect-card">
  <p class="eyebrow">Application Android</p>
  <h1>{{ title }}</h1>
  <p class="lead">{{ description }}</p>
  <p class="status" *ngIf="isAndroidDevice && !invalidLink">
    Si l’application est installée et liée au domaine, ce bouton ouvrira directement AfriFood.
  </p>

  <div class="actions">
    <a *ngIf="!invalidLink" [href]="appLinkUrl">Ouvrir l’application</a>
    <a [href]="playStoreUrl" target="_blank" rel="noopener">Télécharger l’application</a>
    <a routerLink="/">Retour à l’accueil</a>
  </div>
</section>
